export default "__VITE_ASSET__BTUWkjKm__"